var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.274292,
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_290_345",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_290_345",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACkUlEQVR4nO2dO4sUQRRGz26gBiI+UEzUwMBXYGC6/gFBMFCMNBIRwdhIWDEwEzYSxcxMEATBxFSUBf0DPjODVRQFFRUtWexgmWCnZ6dn7+2tc+CmM/T3VX23u6iuBhEREREREREREWnDOaAMKZkQh4HvGhDDFuBNC/GdARNgGnjUUnwNmABXRxBfAzpiHXACuA/80YDV4wgwByyMKLozYAx2A5eBl2OIrgEjshk4CzwG/nYkvD1gCOuB48A94GfHomtAi1z/MEHRNWCAPU2uv1ol0TWA/0+r54EnE8h1DQjOdQ0YWBqYaXL9YwLBq4mg/cAs8DqByNUYsHVJrkcLW40BG5bk+q8EglZhwHST67eALwlErMaAg02uv00gXDUGbOthrvfegMVcPwU87Gmu99KApbn+NYEwpRYDDjW5/i6BGKWPBoz7B6XyGhsNQANKgpHsDCBeTCOIeEHtAfSrbMJoQPgoLM6AeCGKERQvRgkoewAaED4KizMgXohiBMWLUQLKHoAGhI/C4gyIF6IYQfFilICyB6AB4aOwOAPihShGULwYJaDsAWhA+CgsfZ4B4+LGrCS4NTERbs5NxE7gRoKsXrM9oA3XEwhVrQFTa3zndHpmEohUtQGzCUSq2oC5BCJVbcCFDi/2RwLBe/mW5KcOLnTxnIhNwOlkL//1gmMtT6Fdrm4O/OZ24BIwrwHtOADcBb6tULCjy/z2PuBa0O1u79gInGlOp/3d8iKfN88Tw5hqjLoNfNaA4exoYuTZMmItNCuuK1mPOgk88NC+duwFrgAvmn7xHrgD7KKbG4GLwFMjKB4Pbk2ERxcnwcO7e7x2JR3jBxwS4CdMEuBHfBKw+MRuDxAREREREREREdrwD51TO0BUkQqQAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.1da1361e9fff34b23dba1cd66e52bd07.svg";
export { ForwardRef as ReactComponent };